<template>
  <d-window ref="window" v-bind="bindWindow" class="c-menu">
    <template v-slot:control="binds">
      <slot
        v-bind="binds"
        :value="propSelected"
        :items="items"
        :names="names"
        :progress="progress"
      />
    </template>
    <template v-slot:window>
      <slot name="window"/>
      <c-list
        ref="menu"
        class="c-menu__list px-2 py-2"
        margin-item="4px"
        v-bind="bindList"
        @on-click="onInput"
        @on-group="onGroup"
      />
    </template>
  </d-window>
</template>

<script>
import CList from '@/components/CList'
import DWindow from 'dcode/components/DWindow'
import { props } from '@/components/CMenu/props'
import { computed } from 'vue'
import getExp from 'dcode/functions/getExp'
import attrItem from '@/components/CItem/attrItem'
import attrWindow from 'dcode/components/DWindow/attrWindow'
import useObjectList from 'dcode/uses/useObjectList'
import useFocus from 'dcode/components/DMenu/useFocus'
import useSelected from 'dcode/components/DMenu/useSelected'

export default {
  name: 'CMenu',
  components: {
    CList,
    DWindow
  },
  props,
  emits: ['on-input'],
  setup (props, context) {
    const {
      progress,
      object,
      propList,
      propGroup,
      beforeOpening,
      onGroup
    } = useObjectList(props)

    const {
      propSelected,
      items,
      names,
      onInput
    } = useSelected(
      props,
      object,
      context
    )

    const {
      menu,
      window,
      focus,
      search,
      opening
    } = useFocus(
      propSelected,
      object
    )

    const propFilter = computed(() => {
      if (
        props.filter.length > 0 &&
        propList.value.length > 1
      ) {
        const exp = getExp(props.filter, '(:value)')

        return propList.value.filter(item =>
          item.text?.toString().match(exp) ||
          item.description?.toString().match(exp) ||
          item.value?.toString().match(exp)
        )
      } else {
        return propList.value
      }
    })

    const bindList = attrItem({
      props,
      items: {
        focus,
        underline: computed(() => props.underline || props.filter || search.value),
        selected: propSelected
      },
      attrs: {
        list: propFilter,
        group: propGroup,
        size: 'compact'
      }
    })

    const bindWindow = attrWindow({
      props,
      items: {
        beforeOpening,
        opening,
        autoClose: computed(() => !props.multiple && props.windowAutoClose)
      },
      attrs: { adaptive: 'auto' }
    })

    return {
      focus,
      menu,
      window,
      propSelected,
      items,
      names,
      progress,
      bindList,
      bindWindow,
      onInput,
      onGroup
    }
  }
}
</script>

<style lang="scss">
@import "style";
</style>
